module.exports = __webpack_public_path__ + "static/media/logo.6ef09d7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/img/logo.svg
// module id = 115
// module chunks = 0